import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, mergeProps as _mergeProps, createCommentVNode as _createCommentVNode } from "vue";
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_g_cms_block = _resolveComponent("g-cms-block");
    return (_openBlock(), _createElementBlock("div", _mergeProps({ class: "row" }, _ctx.content?.config?.row), [
        (_ctx.content.slots)
            ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_ctx.content.slots, (slot, index) => {
                return (_openBlock(), _createElementBlock("div", _mergeProps({ class: "col" }, slot._column), [
                    _createVNode(_component_g_cms_block, { content: slot }, null, 8, ["content"])
                ], 16));
            }), 256))
            : _createCommentVNode("", true)
    ], 16));
}
